import { executionRequirementShape } from '@/utils/transformFrontendCareGapAction';
import useFeatureFlag from '@/utils/useFeatureFlag';
import DynamicFormExternalNPI from '@/components/DynamicForm/fieldComponents/DynamicFormExternalNPI';

export default function DynamicFormExternalNPIWrapper({ field }) {
  const isFeatureEnabled = useFeatureFlag('enableProviderOutsideOfPractice');
  if (isFeatureEnabled) {
    return <DynamicFormExternalNPI field={field} />;
  }
  return null;
}

DynamicFormExternalNPIWrapper.propTypes = {
  field: executionRequirementShape.isRequired,
};
